"use strict";

var map = require("../Strict/map.js");

var toIter = require('../Strict/toIter.js');

var curry = require('../Strict/curry.js');

var go = require("../Strict/go.js");

var mapL = require("./mapL.js");

var rangeL = require("./rangeL.js");

var takeWhileL = require("./takeWhileL.js");

var some = require("../Strict/some.js");

module.exports = curry(function zipL(...iterables) {
  const iterators = map(toIter, iterables);
  return go(rangeL(Infinity), mapL(_ => map(it => it.next(), iterators)), takeWhileL(some(cur => !cur.done)), mapL(map(cur => cur.value)));
});